(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/react/deposit-shared/use-success-cleanup.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/react/deposit-shared/use-success-cleanup.js');
'use strict';

const {
  useCallback
} = React;
const sharedTracking = svs.accountservicesReact.deposit.tracking.sharedTracking;
const sharedHelpers = svs.accountservicesReact.deposit.helpers.sharedHelpers;
const {
  accountBalanceChangeAction,
  clearFormsDataAction,
  instantPayClear
} = svs.accountservicesReact.deposit.store.deposit.actions;
const useSuccessCleanup = () => {
  const dispatch = ReactRedux.useDispatch();
  const returnUrl = ReactRedux.useSelector(state => state.deposit.returnUrl);
  const selectedDepositMethod = ReactRedux.useSelector(state => state.deposit.selectedDepositMethod);
  const instantPayProduct = ReactRedux.useSelector(state => state.deposit.instantPay.product);
  const successCleanup = useCallback(async _ref => {
    let {
      amount,
      accountBalance
    } = _ref;
    dispatch(clearFormsDataAction());
    const promises = [sharedHelpers.updateBalanceAsync(accountBalance), sharedTracking.trackSuccess(selectedDepositMethod, amount, instantPayProduct), dispatch(instantPayClear())];
    if ((returnUrl === null || returnUrl === void 0 ? void 0 : returnUrl.length) > 0) {
      await sharedHelpers.removeUrlAfterPayServerAsync();
    }
    const [newAccountBalance] = await Promise.all(promises);
    dispatch(accountBalanceChangeAction(newAccountBalance));
    return newAccountBalance;
  }, [dispatch, returnUrl, selectedDepositMethod, instantPayProduct]);
  return successCleanup;
};
svs.accountservicesReact.deposit.depositShared.useSuccessCleanup = useSuccessCleanup;

 })(window);